module.exports = __webpack_public_path__ + "static/img/left_logo_84x52.0393b18.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/left_logo_84x52.gif
// module id = Pc9v
// module chunks = 43